import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

@Component({
	selector: 'app-button',
	imports: [CommonModule, RouterModule, LucideAngularModule],
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
})
export class ButtonComponent {
	@Input() label = '';
	@Input() icon?: string;
	@Input() disabled = false;
	@Input() loading = false;
	@Input() size: 'large' | 'medium' | 'small' | 'xsmall' = 'medium';
	@Input() variant:
		| 'primary'
		| 'secondary'
		| 'tertiary'
		| 'icon-only'
		| 'icon-only-secondary'
		| 'icon-ghost'
		| 'ghost'
		| 'link' = 'primary';
	@Input() type: 'button' | 'submit' | 'reset' = 'button';
	@Input() routerLink?: string | string[];
	/** Accessible name; required when the button only shows an icon. Falls back to the label. */
	@Input() ariaLabel?: string;

	@Output() onClick = new EventEmitter<Event>();

	handleClick(event: Event): void {
		if (!this.disabled && !this.loading) {
			this.onClick.emit(event);
		}
	}

	get isIconOnly(): boolean {
		return !!this.icon && !this.label;
	}

	getButtonClasses(): string[] {
		const classes = [this.size, this.variant];
		if (this.isIconOnly) {
			classes.push('icon-only');
		}
		return classes;
	}
}
